import React, { useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import { SvgIcon } from '@mui/material';
import { ReactComponent as ChevronTopIcon } from '../icons/chevron--top.svg';
import { ReactComponent as ChevronDownIcon } from '../icons/chevron--down.svg';
import { INavigationItem } from './NavigationItems';
import { useLocation } from "react-router-dom";

export interface INavigationItemProps extends INavigationItem {
}

function NavigationItem(props: INavigationItemProps) {
    const { icon, label, children, path, rootPath } = props;
    const hasChildren = (children?.length ?? 0) > 0;

    const location = useLocation();
    const fullPath = path ? `${rootPath}/${path}` : rootPath;
    const selected = fullPath !== '' && location.pathname.startsWith(fullPath);

    // Start expanded when the current route lives inside this section.
    const [open, setOpen] = useState(selected);

    const handleToggle = () => {
        // Pure expand/collapse — keep the user on the page they are on.
        // Leaf items navigate through the router link below (no full page reload).
        if (hasChildren) setOpen((value) => !value);
    }

    return (
        <>
            {/* The theme makes ListItemButton a router Link by default. For an
                expandable parent we render a plain element so the expand/collapse
                click only toggles and never navigates. */}
            <ListItemButton {...(hasChildren ? { component: 'div' as const } : { href: fullPath === '' ? '/' : fullPath })} selected={location.pathname === fullPath} onClick={() => handleToggle()}>
                {icon ? <ListItemIcon>
                    <SvgIcon component={icon} inheritViewBox />
                </ListItemIcon> : null}
                <ListItemText primary={label} />
                {children ? (open ?
                    <SvgIcon component={ChevronTopIcon} inheritViewBox /> :
                    <SvgIcon component={ChevronDownIcon} inheritViewBox />
                ) : null}
            </ListItemButton>
            {children ? <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding dense>
                    {children.map(({ id, label, path }) => {
                        const childPath = fullPath + '/' + path;
                        return (
                            <ListItemButton href={childPath} key={id} sx={{ pl: 8 }} selected={location.pathname === childPath}>
                                <ListItemText primary={label} />
                            </ListItemButton>
                        )
                    })}
                </List>
            </Collapse> : null}
        </>
    );
}

export default NavigationItem;